import { useEffect, useState } from 'react';

import type { TTotpEnrollment } from '@/services/auth';

import { authService } from '@/services/auth';
import { errorUtils } from '@/services/errors';

type TEnrollmentState = {
  enrollment: TTotpEnrollment | null;
  errorCode: string | null;
};

const useTotpEnrollment = (enabled: boolean) => {
  const [state, setState] = useState<TEnrollmentState>({ enrollment: null, errorCode: null });

  useEffect(() => {
    if (!enabled) {
      return;
    }

    authService.enrollTotp().then((result) => {
      if (errorUtils.isNetworkError(result)) {
        setState({ enrollment: null, errorCode: result.code });

        return;
      }

      setState({ enrollment: result, errorCode: null });
    });
  }, [enabled]);

  return state;
};

export type {
  TEnrollmentState,
};
export {
  useTotpEnrollment,
};
